import { useNavigate } from 'react-router-dom';
import { AlertTriangle, Ban, ShieldAlert } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import StarrySkyBackground from '@/components/StarrySkyBackground';

const ErrorContainer = ({ children }) => (
  <div className="flex items-center justify-center min-h-[calc(100vh-4rem)] p-4">
    <StarrySkyBackground showAurora={true} showClouds={true} showShootingStar={false} />
    <Alert className="max-w-md bg-background/95 backdrop-blur-sm">
      {children}
    </Alert>
  </div>
);

export const Error403 = () => {
  const navigate = useNavigate();

  return (
    <ErrorContainer>
      <Ban className="w-6 h-6 text-destructive" />
      <AlertTitle className="mb-2 text-xl">Access Denied</AlertTitle>
      <AlertDescription className="space-y-4">
        <p>You don't have permission to access this story. Please sign in or check your access rights.</p>
        <div className="flex gap-4">
          <Button onClick={() => navigate('/signin')} variant="default">
            Sign In
          </Button>
          <Button onClick={() => navigate('/library')} variant="outline">
            Return to Library
          </Button>
        </div>
      </AlertDescription>
    </ErrorContainer>
  );
};

export const Error404 = () => {
  const navigate = useNavigate();

  return (
    <ErrorContainer>
      <AlertTriangle className="w-6 h-6 text-destructive" />
      <AlertTitle className="mb-2 text-xl">Story Not Found</AlertTitle>
      <AlertDescription className="space-y-4">
        <p>We couldn't find the story you're looking for. It may have been deleted or never existed.</p>
        <div className="flex gap-4">
          <Button onClick={() => navigate('/library')} variant="default">
            Return to Library
          </Button>
          <Button onClick={() => navigate('/create')} variant="outline">
            Create New Story
          </Button>
        </div>
      </AlertDescription>
    </ErrorContainer>
  );
};

export const Error500 = () => {
  const navigate = useNavigate();

  return (
    <ErrorContainer>
      <ShieldAlert className="w-6 h-6 text-destructive" />
      <AlertTitle className="mb-2 text-xl">Something Went Wrong</AlertTitle>
      <AlertDescription className="space-y-4">
        <p>We're having trouble loading this story. Please try again later or return to your library.</p>
        <div className="flex gap-4">
          <Button onClick={() => window.location.reload()} variant="default">
            Try Again
          </Button>
          <Button onClick={() => navigate('/library')} variant="outline">
            Return to Library
          </Button>
        </div>
      </AlertDescription>
    </ErrorContainer>
  );
};

export default {
  Error403,
  Error404,
  Error500
};
